import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Space, Divider, Form, Checkbox } from 'antd';

import RentDeposits from './RentDeposits';
import LeaseDates from './LeaseDates';
import RentableItems from './RentableItems';
import RentalIncentives from './RentalIncentives';
import Deposits from './Deposits';
import Fees from './Fees';
import { getTenancyLaw } from '../store/actions';
import Services from './Services';
import Utilities from './Utilities';

const StyledSpace = styled(Space)`
  width: 100%;
`;

const AdditionalInformation = ({ disableRentForm, selectedUnit, selectedApplicant, mode }) => {
  const [tenancyLaw, setTenancyLaw] = useState({});

  const loadTenancyLaw = useCallback((unitId, leaseStartDate) => {
    getTenancyLaw(unitId, leaseStartDate)
      .done((res) => {
        setTenancyLaw(res.tenancy_law);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const form = Form.useFormInstance();
  const values = Form.useWatch([], form);

  useEffect(() => {
    if (values && values.lease_start_date) {
      loadTenancyLaw(selectedUnit.id, values.lease_start_date);
    }
  }, [values?.lease_start_date]);

  return (
    <>
      <Form.Item name="is_draft" hidden valuePropName="checked">
        <Checkbox />
      </Form.Item>{' '}
      <StyledSpace
        direction="vertical"
        size="middle"
        split={<Divider style={{ margin: '8px 0' }} />}
      >
        <LeaseDates selectedUnit={selectedUnit} tenancyLaw={tenancyLaw} />
        <RentDeposits disabled={disableRentForm} selectedUnit={selectedUnit} />
        <Deposits applicantDeposits={selectedApplicant?.deposits} />
        <RentableItems selectedUnit={selectedUnit} />
        <RentalIncentives selectedUnit={selectedUnit} />
        <Fees selectedUnit={selectedUnit} />
        <Services selectedUnit={selectedUnit} mode={mode} />
        <Utilities selectedUnit={selectedUnit} mode={mode} />
      </StyledSpace>{' '}
    </>
  );
};

AdditionalInformation.propTypes = {
  disableRentForm: PropTypes.bool,
  selectedUnit: PropTypes.object,
};

export default AdditionalInformation;
